/**
 * Fleet separation: which aircraft are about to be too close to each other.
 *
 * `closestM` is the number that matters, not `separationM`. Two aircraft
 * comfortably apart right now and closing head-on are the case a distance-only
 * readout misses entirely.
 */

import { api, type ApiResult } from '@/api/client';

export interface Conflict {
  a: string;
  b: string;
  separationM: number;
  closestM: number;
  timeToClosestS: number;
  severity: 'warn' | 'critical';
}

export interface SeparationReport {
  tracked: number;
  conflicts: Conflict[];
}

export function getSeparation(): Promise<ApiResult<SeparationReport>> {
  return api.get<SeparationReport>('/separation', { logged: false });
}
